import { useEffect, useState } from "react";
import type { Message } from "../../types/message";
import { MessageBubble } from "./message-bubble";

export default function VideoMessage({ message }: { message: Message }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (message.url) {
      setIsLoading(true);
      setHasError(false);
    }
  }, [message.url]);

  if (!message.url) return null;

  return (
    <MessageBubble message={message}>
      <div className="relative inline-block max-w-full overflow-hidden rounded-lg sm:max-w-[420px] max-w-[320px]">
        {hasError ? (
          <div className="flex min-h-24 w-full flex-col items-center justify-center gap-2 bg-slate-200 px-4 py-3 text-xs text-slate-600">
            <span>Video indisponivel</span>
            <a
              href={message.url}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-slate-800 hover:underline"
            >
              Abrir arquivo
            </a>
          </div>
        ) : (
          <>
            <div
              className={`absolute inset-0 bg-slate-200 ${
                isLoading ? "animate-pulse" : "opacity-0"
              }`}
              aria-hidden="true"
            />
            <video
              className={`h-auto max-h-[240px] w-full rounded-lg object-contain transition-opacity duration-150 sm:max-h-[320px] ${
                isLoading ? "opacity-0" : "opacity-100"
              }`}
              controls
              playsInline
              preload="metadata"
              onLoadedData={() => setIsLoading(false)}
              onError={() => {
                setIsLoading(false);
                setHasError(true);
              }}
            >
              <source
                src={message.url}
                type={message.contentType || "video/mp4"}
              />
              Seu navegador nao suporta video.
            </video>
          </>
        )}
      </div>
    </MessageBubble>
  );
}
